<!-- 隐患整改 -->
<template>
  <div class="nx-list-page">
    <!-- 仅两张统计卡：span 12+12 占满一行（span=8 时合计 16/24 右侧留白） -->
    <matrix-statistics span="12" :list="infoCardData(cardData)"></matrix-statistics>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="onSearchChange"
      @search-reset="onSearchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      :beforeOpen="beforeOpen"
      @on-load="onLoad"
      @row-del="rowDel"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExport"
        >
          导出
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="timeAndUser">
        <div>{{ row.updateName }}</div>
        <div>{{ row.updateTime }}</div>
      </template>
      <template #menu="{ size, row }">
        <el-button
          v-if="row.acceptanceResult == 0 && row.rectifyStatus == 2"
          type="text"
          :size="size"
          icon="el-icon-edit"
          @click="handelAcceptance('add', row)"
        >
          验收
        </el-button>
        <el-button
          v-if="row.rectifyStatus != 2 || row.acceptanceResult == 2"
          type="text"
          :size="size"
          icon="el-icon-edit"
          @click="handelClearance('add', row)"
        >
          处理
        </el-button>
      </template>
    </avue-crud>
    <dialog-reset slotShow height="75vh" top="5vh" width="80%" title="新增" :visible.sync="formVisible">
      <detail-form ref="detailFormAdd" :transmit-data="transmitData" @handleClose="handleClose" />
    </dialog-reset>
    <dialog-reset slotShow height="80vh" top="2vh" width="80%" title="详情" :visible.sync="performVisible">
      <detail-form ref="detailFormView" :transmit-data="transmitData" @handleClose="handleClose" />
    </dialog-reset>
    <dialog-reset slotShow height="80vh" top="2vh" width="80%" title="整改验收" :visible.sync="acceptanceVisible">
      <div class="acceptance-dialog-body">
        <detail-form ref="detailFormAcceptance" :transmit-data="transmitData" @handleClose="handleClose" />
        <div class="acceptance-form-panel">
          <div class="acceptance-form-title">验收信息</div>
          <avue-form
            ref="acceptanceForm"
            v-model="acceptanceForm"
            :option="acceptanceFormOption"
          />
        </div>
        <div class="acceptance-dialog-footer">
          <el-button type="success" :loading="acceptanceLoading" @click="acceptanceUp(true)"><i class="el-icon-check"></i>验收通过</el-button>
          <el-button type="danger" :loading="acceptanceLoading" @click="acceptanceUp(false)"><i class="el-icon-close"></i>验收不通过</el-button>
        </div>
      </div>
    </dialog-reset>

    <dialog-reset slotShow height="40vh" top="20vh" width="50%" title="整改验收" :visible.sync="CompletionVisible">
      <confirmation-completion :transmit-data="transmitData" @handleClose="handleClose" />
    </dialog-reset>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, remove, acceptance, getCardData, getDeptTree, exportExcel } from "./api";
import { downloadXls } from "@/util/util";
import DetailForm from "./components/detail-form.vue";
import ConfirmationCompletion from "./components/confirmation-completion.vue";
import matrixStatistics from "@/components/matrix/matrix-statistics.vue";

export default {
  name: "DispatchRectificationPitfallIndex",
  mixins: [crudMixins],
  components: {
    DetailForm,
    ConfirmationCompletion,
    matrixStatistics,
  },
  computed: {
    infoCardData () {
      return function (info) {
        const rows = Array.isArray(info)
          ? info
          : (info ? [info] : []);
        const getRectifyCount = (status) => {
          const row = rows.find(item => Number(item.rectifyStatus) === status);
          return row && row.rectifyCount != null ? row.rectifyCount : 0;
        };
        return [
          {
            label: "待整改",
            value: getRectifyCount(0),
            unit: " 条",
          },
          {
            label: "整改中",
            value: getRectifyCount(1),
            unit: " 条",
          },
        ];
      };
    },
  },

  data () {
    return {
      cardData: [
        {
          rectifyCount: 0,
          rectifyStatus: 0,
        },
      ],
      transmitData: {},
      formVisible: false,
      performVisible: false,
      acceptanceVisible: false,
      CompletionVisible: false,
      exportLoading: false,
      acceptanceLoading: false,
      acceptanceForm: {
        acceptancePhotos: "",
        acceptanceSiteInfo: "",
      },
      acceptanceFormOption: {
        ...this.$store.state.formOption,
        submitBtn: false,
        emptyBtn: false,
        labelWidth: 120,
        span: 24,
        column: [
          {
            label: "验收照片",
            prop: "acceptancePhotos",
            type: "upload",
            multiple: true,
            drag: true,
            tip: "支持多图上传，最多可上传5张图片",
            limit: 5,
            action: `/api/blade-resource/oss/endpoint/put-file-attach`,
            propsHttp: { res: "data", url: "link" },
            dataType: "string",
            listType: "picture-card",
            rules: [
              { required: true, message: "请上传验收照片", trigger: "change" },
            ],
          },
          {
            label: "现场信息",
            prop: "acceptanceSiteInfo",
            type: "textarea",
            maxlength: 1000,
            showWordLimit: true,
            minRows: 4,
            rules: [
              { required: true, message: "请填写现场信息", trigger: "blur" },
            ],
          },
        ],
      },
      apiConfig: { getList, remove },
      option: {
        ...this.$store.state.publicOption,
        // 继承全局：stripe: false、border: false
        menuWidth: 200,
        addBtnText: "新增记录",
        addBtn: false,
        editBtn: false,
        column: [
          {
            label: "隐患编号",
            prop: "hazardCode",
            search: true,
            overHidden: true,
            width: 180,
          },
          {
            label: "问题类型名称",
            prop: "problemTypeName",
            search: true,
            overHidden: true,
            width: 180,
          },
          {
            label: "责任部门名称",
            prop: "responsibleDeptName",
            overHidden: true,
          },
          {
            label: "\u8d23\u4efb\u90e8\u95e8",
            prop: "responsibleDeptId",
            type: "select",
            dicData: [],
            props: {
              label: "deptName",
              value: "id",
            },
            search: true,
            hide: true,
            dataType: "string",
          },
          {
            label: "发现日期",
            prop: "discoveryDate",
            overHidden: true,
            search: true,
            type: "date",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
          },
          {
            label: "问题描述",
            prop: "problemDescription",
          },
          {
            label: "整改状态",
            prop: "rectifyStatus",
            type: "select",
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=rectify_status",
            dataType: "string",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              { required: true, message: "请选择整改状态", trigger: "change" },
            ],
            value: 0,
          },
          {
            label: "验收结果",
            prop: "acceptanceResult",
            type: "select",
            overHidden: true,
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=acceptance_result",
            dataType: "string",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              { required: true, message: "请选择验收结果", trigger: "change" },
            ],
            value: 0,
          },
          {
            label: "整改负责人",
            prop: "rectifyPersonName",
            overHidden: true,
          },
          {
            label: "验收人员",
            prop: "acceptancePersonName",
            overHidden: true,
          },
          {
            label: "生成时间",
            prop: "createTime",
            overHidden: true,
          },
          {
            label: "最新更新人/时间",
            prop: "timeAndUser",
            slot: true,
            overHidden: false,
            minWidth: 160,
          },
        ],
      },
    };
  },
  mounted () {
    this.loadDeptOptions();
    this.$nextTick(() => this.initCardData());
  },
  methods: {
    loadDeptOptions () {
      getDeptTree().then(({ data }) => {
        this.findObject(this.option.column, "responsibleDeptId").dicData = data || [];
      });
    },
    onSearchChange (params, done) {
      crudMixins.methods.searchChange.call(this, params, done);
      this.$nextTick(() => this.initCardData());
    },
    onSearchReset () {
      crudMixins.methods.searchReset.call(this);
      this.$nextTick(() => this.initCardData());
    },
    refreshChange () {
      crudMixins.methods.refreshChange.call(this);
      this.$nextTick(() => this.initCardData());
    },
    async handleExport () {
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `隐患整改_${Date.now()}.xlsx`);
        this.$message.success("导出成功");
      } catch (e) {
        console.warn(e);
        this.$message.error((e && e.message) || "导出失败");
      } finally {
        this.exportLoading = false;
      }
    },
    initCardData () {
      const params = {
        ...this.queryData,
      };
      const defaultRow = { rectifyCount: 0, rectifyStatus: 0 };
      getCardData(params)
        .then((res) => {
          const raw = res.data && res.data.data;
          if (raw == null) {
            this.cardData = [defaultRow];
            return;
          }
          this.cardData = Array.isArray(raw) ? raw : [raw];
        })
        .catch(() => {
          this.acceptanceLoading = false;
          this.cardData = [defaultRow];
        });
    },
    beforeOpen (done, type) {
      this.transmitData = {
        type,
        id: this.form.id || null,
      };
      if (type === "view") {
        this.performVisible = true;
      } else {
        this.formVisible = true;
      }
    },
    handelAcceptance (type, item) {
      this.transmitData = { type, id: item.id || null };
      this.resetAcceptanceForm();
      this.acceptanceVisible = true;
    },
    handelClearance (type, item) {
      this.transmitData = { type, id: item.id || null };
      this.CompletionVisible = true;
    },
    acceptanceUp (type) {
      if (!this.acceptanceForm.acceptancePhotos) {
        this.$message.warning("请上传验收照片");
        return;
      }
      if (!this.acceptanceForm.acceptanceSiteInfo) {
        this.$message.warning("请填写现场信息");
        return;
      }
      this.acceptanceLoading = true;
      acceptance({
        ...this.acceptanceForm,
        id: this.transmitData.id,
        acceptanceResult: type ? 1 : 2,
      })
        .then(() => {
          this.acceptanceVisible = false;
          this.resetAcceptanceForm();
          this.onLoad(this.page, this.query);
          this.initCardData();
          this.$message.success(
            type ? "验收通过操作成功!" : "验收不通过操作成功!"
          );
        })
        .catch(() => {
          this.$message.error("操作失败，请重试!");
        });
    },
    resetAcceptanceForm () {
      this.acceptanceForm = {
        acceptancePhotos: "",
        acceptanceSiteInfo: "",
      };
      this.acceptanceLoading = false;
      this.$nextTick(() => {
        if (this.$refs.acceptanceForm) {
          this.$refs.acceptanceForm.clearValidate();
        }
      });
    },
    handleClose () {
      this.formVisible = false;
      this.performVisible = false;
      this.CompletionVisible = false;
      this.acceptanceVisible = false;
      this.resetAcceptanceForm();
      this.onLoad(this.page, this.query);
    },
  },
};
</script>

<style lang="scss" scoped>
.acceptance-dialog-body {
  position: relative;
  padding-bottom: 96px;
  box-sizing: border-box;
}

.acceptance-form-panel {
  margin: 16px 20px 0;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.acceptance-form-title {
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.acceptance-dialog-footer {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px 0;
  background-color: #fff;
  box-sizing: border-box;
}
</style>
